<template>
  <h1 :class="sizes" class="tracking-tight text-brand">
    <span v-if="title" class="bg-clip-text text-transparent bg-gradient-to-r" :class="colours" v-html="title"></span>
    <span v-else class="bg-clip-text text-transparent bg-gradient-to-r" :class="colours">
      <slot></slot>
    </span>
  </h1>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: ""
    },
    size: {
      type: String,
      required: false,
      default: "large"
    },
    colour: {
      type: String,
      required: false,
      default: "blue"
    },
    noMargin: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  computed: {
    colours() {
      if (this.colour === 'white') {
        return 'from-gray-100 to-white';
      }

      return 'from-brand to-brand-light';
    },
    sizes() {
      if (this.size === 'huge') {
        return 'text-3xl font-extrabold'+ (this.noMargin ? '' : ' mb-4');
      }

      if (this.size === 'medium') {
        return 'text-xl font-bold'+ (this.noMargin ? '' : ' mb-4');
      }

      if (this.size === 'small') {
        return 'text-lg font-bold'+ (this.noMargin ? '' : ' mb-2');
      }

      if (this.size === 'base') {
        return 'text-base font-bold'+ (this.noMargin ? '' : ' mb-2');
      }

      return 'text-2xl font-extrabold'+ (this.noMargin ? '' : ' mb-4');
    }
  },
  methods: {},
  mounted() {
  }
}
</script>
